import { EmptyState } from "@similarweb/ui-components";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { translate } from "app/filters/i18nFilter";

import TechnologiesSectionContent from "./TechnologiesSectionContent";

const TechnologiesCompanySectionRoot = () => {
    return (
        <ErrorBoundaryWithLogging
            fallback={
                <Card
                    isEmpty
                    dataAutomation="technologies-tab"
                    renderContent={() => (
                        <EmptyState
                            title={translate("si.company-analysis.company-data.card.empty.header")}
                            subtitle={translate("si.company-analysis.company-data.card.empty.text")}
                        />
                    )}
                    header={
                        <CardHeader
                            title={translate("si.company-analysis.technologies.card.header")}
                            infoTooltip={translate("si.company-analysis.technologies.card.header.info-tooltip")}
                        />
                    }
                />
            }
        >
            <TechnologiesSectionContent />
        </ErrorBoundaryWithLogging>
    );
};

export default TechnologiesCompanySectionRoot;
